import React from 'react'
import {
  Route,
  IndexRoute,
} from 'react-router'
import { routesByValue } from 'helpers/routesConstant'
import App from 'components/App'
import Menus from 'pages/Menus'
import Banners from 'pages/Banners'
import CreateOrEditMenu from 'pages/Menus/children/CreateOrEditMenu'
import MenuLocations from 'pages/Menus/children/MenuLocations'
import ViewAllMenus from 'pages/Menus/children/ViewAllMenus'
import CustomPages from 'pages/CustomPages'
import ViewAllPages from 'pages/CustomPages/children/ViewAllPages'
import ViewPage from 'pages/CustomPages/children/ViewPage'
import RenderPage from 'pages/CustomPages/children/RenderPage'
import ViewAllCategoryBanners from 'pages/Banners/children/CategoryBanners/ViewAllCategoryBanners'
import CreateOrEditCategoryBanner from 'pages/Banners/children/CategoryBanners/CreateOrEditCategoryBanner'
import ViewAllTagBanners from 'pages/Banners/children/TagBanners/ViewAllTagBanners'
import CreateOrEditPage from 'pages/CustomPages/children/CreateOrEditPage'
import GlobalBanner from 'pages/GlobalBanner'
import CategoryBanners from 'pages/Banners/children/CategoryBanners'
import TagBanners from 'pages/Banners/children/TagBanners'
import StoreLocator from 'pages/StoreLocator'
import StoreListManager from 'pages/StoreLocator/StoreListManager'
import StoreTypes from 'pages/StoreLocator/StoreTypes'
import CreateOrEditTagBanner from 'pages/Banners/children/TagBanners/CreateOrEditTagBanner'

import Demo from 'pages/Demo'
import Demo2 from 'pages/Demo/demo2'

import PageLocations from 'pages/CustomPages/children/PageLocations'

export default [
  <Route path={routesByValue.renderPage.value} component={RenderPage} />,
  <Route path="/" component={App}>
    <Route path={routesByValue.menus.value} component={Menus}>
      <IndexRoute component={ViewAllMenus} />
      <Route path={routesByValue.createMenu.value} component={CreateOrEditMenu} />
      <Route path={routesByValue.editMenu.value} component={CreateOrEditMenu} />
      <Route path={routesByValue.manageMenuLocations.value} component={MenuLocations} />
    </Route>
    <Route path={routesByValue.pages.value} component={CustomPages}>
      <IndexRoute component={ViewAllPages} />
      <Route path={routesByValue.editPage.value} component={CreateOrEditPage} />
      <Route path={routesByValue.createPage.value} component={CreateOrEditPage} />
      <Route path={routesByValue.managePageLocations.value} component={PageLocations} />
      <Route path={routesByValue.viewPage.value} component={ViewPage} />
    </Route>
    <Route path={routesByValue.banners.value} component={Banners}>
      <IndexRoute component={GlobalBanner} />
      <Route path={routesByValue.categoryBanner.value} component={CategoryBanners}>
        <IndexRoute component={ViewAllCategoryBanners} />
        <Route
          path={routesByValue.editCategoryBanner.value}
          component={CreateOrEditCategoryBanner}
        />
        <Route
          path={routesByValue.createCategoryBanner.value}
          component={CreateOrEditCategoryBanner}
        />
      </Route>
      <Route path={routesByValue.tagBanner.value} component={TagBanners}>
        <IndexRoute component={ViewAllTagBanners} />
        <Route path={routesByValue.editTagBanner.value} component={CreateOrEditTagBanner} />
        <Route path={routesByValue.createTagBanner.value} component={CreateOrEditTagBanner} />
      </Route>
    </Route>
    <Route path={routesByValue.globalBanner.value} component={GlobalBanner} />
    <Route path={routesByValue.storeLocator.value} component={StoreLocator}>
      <Route path={routesByValue.manageStoreList.value} component={StoreListManager} />
      <Route path={routesByValue.manageStoreLocatorTypes.value} component={StoreTypes} />
    </Route>
    <Route path="demo" component={Demo} />
    <Route path="demo2" component={Demo2} />
  </Route>,
]



// WEBPACK FOOTER //
// ./src/routes/routes.js